import Vue from "vue";
import store from "@/store";

const CustomNotificationUtils = {
    lsKey: "custom_notification_popup_notified",
    /* Checking if the user is logged in, and if the community is suspended. If either of those are
    true, it returns false. Otherwise, it returns the opposite of `hasNotified`. */
    shouldNotify() {
        if (!store.state.user) {
            return false;
        }
        if (
            store.state.current_community &&
            store.state.current_community.suspended
        ) {
            return false;
        }
        return !this.hasNotified();
    },
    /* It's checking if the user has been notified about the custom notification popup. */
    hasNotified() {
        let notified = Vue.ls.get(this.lsKey);
        if (!notified) {
            return false;
        }
        return JSON.parse(notified);
    },
    /* It's setting the value of `custom_notification_popup_notified` in local storage. */
    setNotified(notified) {
        Vue.ls.set(this.lsKey, JSON.stringify(notified));
    },
};

export default CustomNotificationUtils;
